import { AxiosError } from 'axios';
import { useQuery } from 'react-query';
import { Axios } from '@utils/api/axios-instance.ts';
import { GET_URL } from '@utils/api/endpoints.ts';
import { BaseError } from '@utils/types/shared/base.ts';
import { useAppSearchParams } from '@utils/hooks/use-app-search-params.ts';
import { getEncodedFilters } from '@utils/extensions/filter.extension.ts';

export interface CustomerGroupBoIAM {
  id: number;
  name: string;
  description: string;
}

export interface CustomerBoGroupIAMResponse {
  count: number;
  total_results: number;
  result: CustomerGroupBoIAM[];
}

export const useGetCustomerGroupsBoIAM = (id: number) => {
  const { searchParams, filters } = useAppSearchParams();
  const offset = parseInt(searchParams.offset || '0');
  const limit = parseInt(searchParams.limit || '25');
  const filtersString = getEncodedFilters(filters);

  const fetchCustomerGroupIAM = async (
    offset: number,
    limit: number,
    filters: string
  ) => {
    const response = await Axios.get<CustomerBoGroupIAMResponse>(
      `${
        GET_URL(
          id.toString(),
          offset.toString(),
          limit.toString(),
          filters.toString()
        ).customerBoGroupIAM
      }`
    );
    return response.data;
  };

  return useQuery<CustomerBoGroupIAMResponse, AxiosError<BaseError>>(
    ['customerGroup', id, offset, limit, filtersString],
    () => fetchCustomerGroupIAM(offset, limit, filtersString),
    {
      useErrorBoundary: false
    }
  );
};
